import { Sellable } from '../shared/sellable';
import { AddonKey } from '@vendasta/marketplace-packages';

export class Package extends Sellable {
  solution_id: string;
  partner_id: string;
  market_id: string;
  name: string;
  icon: string;
  status: string;
  tagline: string;
  header_image_url: string;
  content: string;
  products: string[];
  addon_keys: AddonKey[];
  hide_product_icons_and_names: boolean;
  hide_product_details: boolean;
  createdDate: Date;
  updatedDate: Date;
  productOrder: string[]; // the order the product / addons in the package

  static fromApi(data: any): Package {
    const newPackage = new Package();
    if (!data.pricing && data.selling_price) {
      data.pricing = {
        currency: data.currency,
        prices: [
          {
            price: data.selling_price * 100,
            frequency: data.billingFrequency,
            isStartingPrice: false,
          },
        ],
      };
    }
    Object.assign(newPackage, data);
    if (!newPackage.name) {
      newPackage.name = 'Untitled';
    }
    if (data.created) {
      newPackage.createdDate = new Date(data.created);
    }
    if (data.updated) {
      newPackage.updatedDate = new Date(data.updated);
    }
    return newPackage;
  }

  get isPackageFree(): boolean {
    return this.isFree;
  }
}
